import { render, staticRenderFns } from "./Invoice3PL.vue?vue&type=template&id=2833c51c&"
import script from "./Invoice3PL.vue?vue&type=script&lang=js&"
export * from "./Invoice3PL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports